module.exports = __webpack_public_path__ + "img/hamberger_02_02.7d1e08a3.png";